// extracted by mini-css-extract-plugin
export default {"mainContainer":"dialog-layout_mainContainer__ujKPF","logo":"dialog-layout_logo__EXtt2"};